module.exports = __webpack_public_path__ + "assets/images/ecc796e9ba3754f533e264bba1cf0166.svg";